<template>
  <v-app id="app">
    <NavBar />
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-slide-y-transition mode="out-in">
          <router-view/>
        </v-slide-y-transition>
      </v-container>
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import NavBar from './components/layout/NavBar'
import Footer from './components/layout/Footer'
export default {
  name: 'App',
  components: {
    NavBar,
    Footer
  },
  created(){
    this.autoLogin();
  },
  methods: {
    ...mapActions("usuarioNamespace", ["autoLogin"]),
  },
};
</script>
